import { useContext, useEffect, useState } from "react";
import { useOutletContext } from "react-router";
import styled, { css } from "styled-components";
import PremiumContentProtectiveLayer from "../../../sharable/PremiumContentProtectiveLayer";
import FeedCanvas from "../../CanvasViewer/Canvas/FeedCanvas";
import {
  CESTA_BASICA_KIT,
  FEED_INSTAGRAM,
  FEED_INSTAGRAM_PORTRAIT,
  PANFLETO,
  STORIES,
} from "../../CanvasViewer/EncarteConstants";
import { MenuDescription, MenuTitle } from "../Toolbar";

import {
  copyProductPropertiesWithStyles,
  copyStylesWithoutProperties,
} from "../../../../services/Utils";
import Loading from "../../../sharable/Loading";
import PanfletoCanvas from "../../CanvasViewer/Canvas/PanfletoCanvas";
import StoriesCanvas from "../../CanvasViewer/Canvas/StoriesCanvas";
import { processProductsWithThemeStyles } from "../../Editor/processesProductsWithThemeStyles";
import WorkspaceContext from "../../WorkspaceContext";
import {
  FEED_GRIDS,
  PANFLETO_GRID,
  STORIES_GRIDS,
} from "../GridMenuView/Grids";
import CestaBasicaKitCanvasViewer from "../../CanvasViewer/CestaBasicaKitCanvasViewer/CestaBasicaKitCanvasViewer";
const Container = styled.div`
  width: 100%;
  max-width: 100%;
  height: calc(100vh - 8.4rem);
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  ${({ isAccountPremium }) =>
    !isAccountPremium &&
    css`
      overflow-y: hidden;
      main {
        filter: blur(3px);
      }
    `}

  .switch-wrapper {
    margin-bottom: 2rem;
  }
  .switch-span {
    font-size: 1.6rem;
    margin-bottom: 1rem;
    display: inline-block;
  }

  .grade-active-message {
    text-align: center;
    font-size: 1.6rem;
  }
`;
const GridListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;
const GridSlide = styled.div`
  display: flex;
  gap: 2rem;
  overflow-x: auto;
`;
const GridWrapper = styled.div`
  display: flex;
  cursor: pointer;
`;
const GridList = styled.div`
  h1 {
    font-size: 2rem;
  }
`;

const canvasScale = 0.2;
export default function GridMenuView() {
  const { onGridChange, styles, products, canvasScale } =
    useContext(WorkspaceContext);
  const { isAccountPremium } = useOutletContext();

  return (
    <Container isAccountPremium={isAccountPremium}>
      {!isAccountPremium && <PremiumContentProtectiveLayer />}
      <main>
        <MenuDescription>
          Escolha como deseja exibir os produtos no seu encarte. Clique em uma
          das opções de grade abaixo para aplicá-la ao seu encarte.
        </MenuDescription>

        <>
          {" "}
          <MenuTitle>Grade de Produtos</MenuTitle>
          {(styles.format === FEED_INSTAGRAM ||
            styles.format === FEED_INSTAGRAM_PORTRAIT) && (
            <GridListWrapper>
              {FEED_GRIDS.map((gridList) => (
                <GridList>
                  <h1>{gridList.title}</h1>
                  <GridSlide canvasScale={canvasScale}>
                    {gridList.gridsArr.map((g) => (
                      <GridFeedCanvas
                        grid={g}
                        onGridChange={onGridChange}
                        products={products}
                      />
                    ))}
                  </GridSlide>
                </GridList>
              ))}
            </GridListWrapper>
          )}
          {styles.format === STORIES && (
            <GridListWrapper>
              {STORIES_GRIDS.map((gridList) => (
                <GridList>
                  <h1>{gridList.title}</h1>
                  <GridSlide canvasScale={canvasScale}>
                    {gridList.gridsArr.map((g) => (
                      <GridStoriesCanvas
                        grid={g}
                        onGridChange={onGridChange}
                        products={products}
                      />
                    ))}
                  </GridSlide>
                </GridList>
              ))}
            </GridListWrapper>
          )}
          {(styles.format === PANFLETO ||
            styles.format === CESTA_BASICA_KIT) && (
            <GridListWrapper>
              {PANFLETO_GRID.map((gridList) => (
                <GridList>
                  <h1>{gridList.title}</h1>
                  <GridSlide canvasScale={canvasScale}>
                    {gridList.gridsArr.map((g) => (
                      <GridPanfletoCanvas
                        grid={g}
                        onGridChange={onGridChange}
                        products={products}
                      />
                    ))}
                  </GridSlide>
                </GridList>
              ))}
            </GridListWrapper>
          )}
        </>
      </main>
    </Container>
  );
}

function GridFeedCanvas({ grid, onGridChange, products }) {
  const { styles, setIsEncarteUpdating, model } = useContext(WorkspaceContext);
  const [canvasProducts, setCanvasProducts] = useState(undefined);
  const [gridProductStyles, setGridProductStyles] = useState();
  useEffect(() => {
    if (!products || products.length === 0) {
      setCanvasProducts(grid.products);
    } else {
      const pArr = updateGridWithExistingProducts(
        grid.products,
        products,
        model,
        setIsEncarteUpdating,
      );
      setCanvasProducts(pArr);
    }
  }, [products, styles]);
  useEffect(() => {
    const stylesCopy = { ...styles };
    stylesCopy.fontSize = 28;
    setGridProductStyles(stylesCopy);
  }, [styles]);
  return (
    <>
      {" "}
      {canvasProducts && gridProductStyles ? (
        <GridWrapper
          onClick={() =>
            onGridChange({ grid: grid.grid, products: canvasProducts })
          }
        >
          <FeedCanvas
            grid={grid.grid}
            products={canvasProducts}
            canvasScale={0.2}
          />
        </GridWrapper>
      ) : (
        <Loading $NoBg txt="Carregando grade de produtos..." />
      )}
    </>
  );
}

function GridStoriesCanvas({ grid, onGridChange, products }) {
  const { styles, setIsEncarteUpdating, model } = useContext(WorkspaceContext);
  const [canvasProducts, setCanvasProducts] = useState();
  styles.fontSize = 32;
  useEffect(() => {
    if (!products || products.length === 0) {
      setCanvasProducts(grid.products);
    } else {
      const pArr = updateGridWithExistingProducts(
        grid.products,
        products,
        model,
        setIsEncarteUpdating,
      );
      setCanvasProducts([...pArr]);
    }
  }, [products, styles]);
  return (
    <>
      {canvasProducts ? (
        <GridWrapper
          onClick={() =>
            onGridChange({ grid: grid.grid, products: canvasProducts })
          }
        >
          <StoriesCanvas
            grid={grid.grid}
            products={canvasProducts}
            canvasScale={canvasScale}
            isProductClickable={false}
            isTargetCanvas={false}
          />
        </GridWrapper>
      ) : (
        <Loading $NoBg color="#fff" txt={"Carregando grade de produtos..."} />
      )}
    </>
  );
}

function GridPanfletoCanvas({ grid, onGridChange, products }) {
  const [canvasProducts, setCanvasProducts] = useState();
  const { styles, setIsEncarteUpdating, model } = useContext(WorkspaceContext);
  useEffect(() => {
    if (!products || products.length === 0) {
      setCanvasProducts(grid.products);
      return;
    } else {
      const pArr = updateGridWithExistingProducts(
        grid.products,
        products,
        model,
        setIsEncarteUpdating,
      );
      setCanvasProducts([...pArr]);
    }
  }, [products, styles]);
  return (
    <>
      {canvasProducts ? (
        <GridWrapper
          onClick={() =>
            onGridChange({ grid: grid.grid, products: canvasProducts })
          }
        >
          {styles.format === PANFLETO && (
            <PanfletoCanvas
              grid={grid}
              products={canvasProducts}
              canvasScale={0.15}
              isProductClickable={false}
            />
          )}

          {styles.format === CESTA_BASICA_KIT && (
            <CestaBasicaKitCanvasViewer
              grid={grid}
              products={canvasProducts}
              canvasScale={0.15}
              isProductClickable={false}
            />
          )}
        </GridWrapper>
      ) : (
        <Loading $NoBg color="#fff" txt={"Carregando grade de produtos..."} />
      )}
    </>
  );
}

const updateGridWithExistingProducts = (
  gridProducts,
  encarteProducts,
  model,
  setIsEncarteUpdating,
) => {
  const pArr = [...gridProducts];
  const maxI =
    gridProducts.length <= encarteProducts.length
      ? gridProducts.length - 1
      : encarteProducts.length - 1;

  for (let i = 0; i <= maxI; i++) {
    const gridProduct = { ...gridProducts[i] };
    const encarteProduct = { ...encarteProducts[i] };
    pArr[i] = copyProductPropertiesWithStyles(encarteProduct, gridProduct);
  }
  //Updating grid product that did not match with any product because GridProducts array is bigger than encarte products
  //Price Style as Image adaptation*
  if (gridProducts.length > encarteProducts.length) {
    //Random selected product to copy styles
    const modelProduct = { ...pArr[0] };

    for (let i = maxI + 1; i <= gridProducts.length - 1; i++) {
      const gridProduct = { ...pArr[i] };
      pArr[i] = copyStylesWithoutProperties(modelProduct, gridProduct);
    }
  }

  return processProductsWithThemeStyles(pArr, model, setIsEncarteUpdating);
};

export const removeProductGridStyles = (encarteProducts) => {
  //return encarteProducts;
  const products = encarteProducts.slice();
  const alteredProducts = [];
  products.forEach((p) => {
    /*NEEDS TO COPY BOTH PRODUCT AND STYLES SO IT DON'T AFFECT GRID.js STYLES */
    const pCopy = { ...p };
    const sCopy = { ...pCopy.styles };

    sCopy.gridRow = "";
    sCopy.gridColumn = "";
    pCopy.styles = sCopy;
    alteredProducts.push(pCopy);
  });
  return alteredProducts;
};
